<template>
  <layout name="LayoutDefault">
    <div class="About">
      <div class="container">
        <div class="contents">
          <div class="row">

            <!-- Desktop Sidebar Filter -->
            <div class="col-lg-3 d-none d-lg-block" id="sidefilter">
              <div class="accordion" id="filter">

                <!-- Sort -->
                <div class="card shadow">
                  <div class="card-header">
                    <span class="filter-cancel" @click="resetSort">মুছে ফেলুন</span>
                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#sectionSortCollapse" aria-expanded="true">বাছাইয়ের ধরন</a>
                  </div>
                  <div id="sectionSortCollapse" class="collapse show">
                    <div class="card-body pt-0">
                      <ul>
                        <li class="checkbox" v-for="opt in sortOptions" :key="opt.value">
                          <input @change="applyAll" type="radio" :id="`dsort_${opt.value}`" name="desktopSort" v-model="selectedSort" :value="opt.value" />
                          <label :for="`dsort_${opt.value}`">{{ opt.label }}</label>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <!-- Categories -->
                <div class="card shadow">
                  <div class="card-header">
                    <span class="filter-cancel" @click="selectedCategory = null; applyAll()">মুছে ফেলুন</span>
                    <a href="#" class="btn btn-header-link" data-toggle="collapse" data-target="#sectionCatCollapse" aria-expanded="true">বিষয়</a>
                  </div>
                  <div id="sectionCatCollapse" class="collapse show">
                    <div class="card-body pt-0">
                      <div class="form-group">
                        <input v-model="categorySearch" type="text" placeholder="খুঁজে দেখুন" class="form-control brand-search" />
                      </div>
                      <ul>
                        <li class="checkbox" v-for="cat in filteredCategories" :key="cat.id">
                          <input @change="applyAll" type="radio" :id="`dcat_${cat.id}`" name="desktopCategory" v-model="selectedCategory" :value="cat.id" />
                          <label :for="`dcat_${cat.id}`">{{ cat.category_name }}</label>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <!-- Authors -->
                <div class="card shadow">
                  <div class="card-header">
                    <span class="filter-cancel" @click="selectedAuthor = null; applyAll()">মুছে ফেলুন</span>
                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#sectionAuthorCollapse" aria-expanded="true">লেখক</a>
                  </div>
                  <div id="sectionAuthorCollapse" class="collapse show">
                    <div class="card-body pt-0">
                      <div class="form-group">
                        <input v-model="authorSearch" type="text" placeholder="খুঁজে দেখুন" class="form-control brand-search" />
                      </div>
                      <ul>
                        <li class="checkbox" v-for="author in filteredAuthors" :key="author.id">
                          <input @change="applyAll" type="radio" :id="`dauthor_${author.id}`" name="desktopAuthor" v-model="selectedAuthor" :value="author.id" />
                          <label :for="`dauthor_${author.id}`">{{ author.author_name }}</label>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <!-- Price Range -->
                <div class="card shadow" v-if="filters.price_ranges && filters.price_ranges.length">
                  <div class="card-header">
                    <span class="filter-cancel" @click="selectedPriceRange = null; applyAll()">মুছে ফেলুন</span>
                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#sectionPriceCollapse" aria-expanded="true">মূল্য</a>
                  </div>
                  <div id="sectionPriceCollapse" class="collapse show">
                    <div class="card-body pt-0">
                      <ul>
                        <li class="checkbox" v-for="(range, idx) in filters.price_ranges" :key="idx">
                          <input @change="applyAll" type="radio" :id="`dprice_${idx}`" name="desktopPrice" v-model="selectedPriceRange" :value="idx" />
                          <label :for="`dprice_${idx}`">{{ range.label }}</label>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <!-- Products -->
            <div class="col-lg-9 col-12">
              <div class="">
                <div v-if="loader">
                  <img slot="preloader" v-bind:src="`${baseUrl}/assets/img/loader.gif`" title="Loading..." />
                </div>
                <div class="row">
                  <div v-for="(item, k) in items" :key="k" class="col-lg-3 col-sm-6 col-6 mb-5">
                    <ProductCard :item="item" />
                  </div>
                </div>
              </div>

              <nav class="d-flex justify-content-center">
                <ul class="pagination">
                  <li v-for="(item, k) in links" :key="k" :class="getPagingClass(item)">
                    <a class="page-link" @click="getProducts(item.url)" href="javascript:;" v-html="getPagingLabel(item)"></a>
                  </li>
                </ul>
              </nav>
            </div>

          </div>
        </div>
      </div>

      <!-- Mobile Sort/Filter Bar -->
      <div class="mobile-sort-filter-bar d-block d-md-none">
        <div class="d-flex">
          <a href="javascript:;" class="sort-filter-btn flex-fill" @click="showSortSheet = true">
            <i class="fas fa-sort-amount-down"></i> Sort
          </a>
          <a href="javascript:;" class="sort-filter-btn flex-fill" @click="showFilterSheet = true">
            <i class="fas fa-filter"></i> Filter
          </a>
        </div>
      </div>

      <!-- Sort Bottom Sheet -->
      <div v-if="showSortSheet" class="sheet-overlay" @click="showSortSheet = false"></div>
      <transition name="slide-up">
        <div v-if="showSortSheet" class="bottom-sheet sort-sheet">
          <div class="sheet-handle"></div>
          <div class="sheet-header">Sort</div>
          <div class="sheet-body">
            <label class="sheet-radio" v-for="opt in sortOptions" :key="opt.value">
              <input type="radio" name="mobileSort" :value="opt.value" v-model="selectedSort" />
              <span>{{ opt.label }}</span>
            </label>
          </div>
          <div class="sheet-actions">
            <button class="btn btn-light btn-reset" @click="resetSort">Reset</button>
            <button class="btn btn-primary btn-apply" @click="applySort">Apply</button>
          </div>
        </div>
      </transition>

      <!-- Filter Bottom Sheet -->
      <div v-if="showFilterSheet" class="sheet-overlay" @click="showFilterSheet = false"></div>
      <transition name="slide-up">
        <div v-if="showFilterSheet" class="bottom-sheet filter-sheet">
          <div class="sheet-handle"></div>
          <div class="sheet-header">Filter</div>
          <div class="sheet-body">

            <label class="sheet-checkbox">
              <input type="checkbox" v-model="inStock" />
              <span>স্টকে আছে</span>
            </label>

            <hr />

            <div class="filter-section">
              <h6 class="filter-title">লেখক</h6>
              <div class="filter-search-wrap">
                <input type="text" class="form-control filter-search" placeholder="Search authors..." v-model="authorSearch" />
                <i class="fa fa-search filter-search-icon"></i>
              </div>
              <div class="filter-options-scroll">
                <label class="sheet-radio" v-for="author in filteredAuthors" :key="author.id">
                  <input type="radio" name="authorFilter" :value="author.id" v-model="selectedAuthor" />
                  <span>{{ author.author_name }}</span>
                </label>
              </div>
            </div>

            <hr />

            <div class="filter-section">
              <h6 class="filter-title">বিষয়</h6>
              <div class="filter-search-wrap">
                <input type="text" class="form-control filter-search" placeholder="Search categories..." v-model="categorySearch" />
                <i class="fa fa-search filter-search-icon"></i>
              </div>
              <div class="filter-options-scroll">
                <label class="sheet-radio" v-for="cat in filteredCategories" :key="cat.id">
                  <input type="radio" name="categoryFilter" :value="cat.id" v-model="selectedCategory" />
                  <span>{{ cat.category_name }}</span>
                </label>
              </div>
            </div>

            <hr />

            <div class="filter-section" v-if="filters.price_ranges && filters.price_ranges.length">
              <h6 class="filter-title">মূল্যসীমা</h6>
              <label class="sheet-radio" v-for="(range, idx) in filters.price_ranges" :key="idx">
                <input type="radio" name="priceRange" :value="idx" v-model="selectedPriceRange" />
                <span>{{ range.label }}</span>
              </label>
            </div>

          </div>
          <div class="sheet-actions">
            <button class="btn btn-light btn-reset" @click="resetFilter">Reset</button>
            <button class="btn btn-primary btn-apply" @click="applyFilter">Apply</button>
          </div>
        </div>
      </transition>

    </div>
  </layout>
</template>

<script>
import Layout from "../layouts/Layout";
import Pagination from "vue-and-pagination";
import ProductCard from "./common/ProductCard.vue";

export default {
  name: `Section`,
  data() {
    return {
      loader: true,
      links: null,
      filterBy: this.$route.query.sort ? this.$route.query.sort : "",
      items: "",
      total: 0,
      filters: { authors: [], categories: [], price_ranges: [] },
      showSortSheet: false,
      showFilterSheet: false,
      selectedSort: "",
      selectedAuthor: null,
      selectedCategory: null,
      selectedPriceRange: null,
      inStock: false,
      authorSearch: "",
      categorySearch: "",
      sortOptions: [
        { label: "বেস্ট সেলার", value: "best_seller" },
        { label: "সদ্য প্রকাশিত", value: "new_released" },
        { label: "মূল্য - কম থেকে বেশি", value: "price_low" },
        { label: "মূল্য - বেশি থেকে কম", value: "price_high" },
        { label: "বেশি ছাড়ের বই", value: "discount_high" },
        { label: "সর্বাধিক পাঠকপ্রিয়", value: "best_rating" },
      ],
    };
  },
  computed: {
    filteredAuthors() {
      if (!this.filters.authors) return [];
      if (!this.authorSearch) return this.filters.authors;
      const q = this.authorSearch.toLowerCase();
      return this.filters.authors.filter(
        (a) =>
          (a.author_name && a.author_name.toLowerCase().includes(q)) ||
          (a.author_name_en && a.author_name_en.toLowerCase().includes(q))
      );
    },
    filteredCategories() {
      if (!this.filters.categories) return [];
      if (!this.categorySearch) return this.filters.categories;
      const q = this.categorySearch.toLowerCase();
      return this.filters.categories.filter(
        (c) =>
          (c.category_name && c.category_name.toLowerCase().includes(q)) ||
          (c.category_name_en && c.category_name_en.toLowerCase().includes(q))
      );
    },
  },
  components: {
    Layout,
    ProductCard,
    Pagination,
  },
  methods: {
    getPagingLabel(item) {
      let string = item.label;
      string = string.replace("Next", "");
      string = string.replace("Previous", "");
      return string;
    },
    getPagingClass(item) {
      if (item.url && item.active === true) {
        return "page-item active";
      } else if (!item.url) {
        return "page-item disabled";
      } else {
        return "page-item";
      }
    },
    buildApiUrl() {
      let url = this.APIURL + "home-sections/" + this.$route.params.id;
      let params = [];
      if (this.selectedSort) params.push("sort=" + this.selectedSort);
      if (this.selectedAuthor) params.push("authors=" + this.selectedAuthor);
      if (this.selectedCategory) params.push("categories=" + this.selectedCategory);
      if (this.selectedPriceRange !== null && this.filters.price_ranges[this.selectedPriceRange]) {
        const range = this.filters.price_ranges[this.selectedPriceRange];
        params.push("price_min=" + range.min);
        if (range.max !== null) params.push("price_max=" + range.max);
      }
      if (this.inStock) params.push("in_stock=1");
      if (params.length) url += "?" + params.join("&");
      return url;
    },
    applyAll() {
      this.loader = true;
      this.getProducts(this.buildApiUrl());
    },
    applySort() {
      this.showSortSheet = false;
      this.applyAll();
    },
    applyFilter() {
      this.showFilterSheet = false;
      this.applyAll();
    },
    resetSort() {
      this.selectedSort = "";
      this.showSortSheet = false;
      this.applyAll();
    },
    resetFilter() {
      this.selectedAuthor = null;
      this.selectedCategory = null;
      this.selectedPriceRange = null;
      this.inStock = false;
      this.authorSearch = "";
      this.categorySearch = "";
      this.showFilterSheet = false;
      this.applyAll();
    },
    getProducts(url) {
      fetch(url)
        .then((response) => response.json())
        .then((json) => {
          this.items = json.data;
          this.loader = false;
          this.links = json.links;
          this.total = json.total || 0;
          if (json.filters) {
            this.filters = json.filters;
          }
          $(".back-to-top").trigger("click");
        });
    },
  },
  mounted() {
    let url = this.APIURL + "home-sections/" + this.$route.params.id;
    if (this.filterBy) url += "?sort=" + this.filterBy;
    this.getProducts(url);
  },
};
</script>

<style>
.About #sidefilter #filter .card .card-header {
  position: relative;
}
.About #sidefilter #filter .card .card-header .btn-header-link {
  padding: 12px 15px;
  font-size: 16px;
}
.About #sidefilter #filter .card .card-header .filter-cancel {
  top: 12px;
  right: 40px;
  font-size: 13px;
}
.About #sidefilter #filter .card .card-body .form-group {
  margin-top: 8px;
}
</style>
